import React from 'react'
import {summarizeSection} from '../../../../utils/skipLogic/summary'

// Read-only review summary of every skip-logic section: each rule phrased as
// "If ... go to ..." plus the default otherwise route. Sections are never shown
// to respondents, but a reviewer needs to see where the survey branches.
export default function SkipLogicReviewSummary({survey, sections = []}) {
  if (!sections.length) return null
  return (
    <div className="review-category-group">
      <div className="review-category-group-title">Skip logic</div>
      {sections.map((section, idx) => {
        const summary = summarizeSection(survey, section)
        return (
          <div
            key={`skip-${section.itemId ?? idx}`}
            className="review-skip-logic-section"
          >
            <div className="review-question-text">Skip logic {idx + 1}</div>
            {summary.rules.length === 0 ? (
              <div className="review-skip-logic-rule">No rules yet.</div>
            ) : (
              summary.rules.map(rule => (
                <div key={rule.number} className="review-skip-logic-rule">
                  {rule.number}. {rule.text}
                </div>
              ))
            )}
            <div className="review-skip-logic-otherwise">{summary.otherwise}</div>
          </div>
        )
      })}
    </div>
  )
}
